'use client';

import type { CSSProperties, ReactNode } from 'react';
import { pushDataLayer } from '@/lib/track-gtm';

interface Props {
  blockId: string;
  blockType: 'button' | 'button-modal' | 'image' | 'hero-cta';
  label: string;
  url: string;
  clickAction?: 'link' | 'modal' | 'salespad';
  target?: string;
  rel?: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

/**
 * Anchor that pushes a `salescal.salespad_click` event into window.dataLayer
 * on click before navigating. Used by blocks rendered as server components
 * (Image, Hero CTA). For blocks that are already client components (Button,
 * ButtonModal) we push inline rather than wrapping in this.
 */
export function TrackedAnchor({
  blockId,
  blockType,
  label,
  url,
  clickAction = 'link',
  target,
  rel,
  className,
  style,
  children,
}: Props) {
  return (
    <a
      href={url}
      target={target}
      rel={rel}
      className={className}
      style={style}
      onClick={() => {
        pushDataLayer('salescal.salespad_click', {
          blockId,
          blockType,
          label,
          url,
          clickAction,
        });
      }}
    >
      {children}
    </a>
  );
}
